module.exports = __webpack_public_path__ + "media/images/top/seminars/top/img_kv_sp-9aa37b223693535159dfb6c74f7325a6.jpg";